import { useQuery } from 'academy-common-lib/utils/DataFetchingClient';
import { GET_CATALOG_RESOURCES_QUERY } from '../../../../__generated__/chirp/com/hubspot/academy/catalog/rpc/v1/CatalogResourceChirpFrontendService.dfc';
import { useGetCatalogResourcesLazyQuery } from '../../../../__generated__/chirp/com/hubspot/academy/catalog/rpc/v1/CatalogResourceChirpFrontendService.hooks';
const toCatalogCardModelsRequest = ({
  id,
  type,
  language: requestedLanguage
}) => {
  let language;
  if (type !== 'SHORT_FORM_CONTENT') {
    language = requestedLanguage === null || requestedLanguage === void 0 ? void 0 : requestedLanguage.toLowerCase();
  }
  return {
    resourceId: id,
    language,
    type
  };
};
export const useCatalogCardModels = ({
  items,
  skip
}) => {
  const {
    data,
    loading: catalogCardModelsLoading,
    error: catalogCardModelsError,
    apolloError
  } = useQuery(GET_CATALOG_RESOURCES_QUERY, {
    variables: {
      requestedResources: items
      // filter out tracks and lessons with no language (bad data)
      .filter(({
        type,
        language
      }) => language || type === 'SHORT_FORM_CONTENT' || type === 'PLAYLIST').map(toCatalogCardModelsRequest)
    },
    skip: skip || !items.length
  });
  return {
    catalogCardModels: data === null || data === void 0 ? void 0 : data.results,
    catalogCardModelsLoading,
    catalogCardModelsError,
    apolloError
  };
};

// Lazy variant of the catalog-resources query. Re-exported under the feature's
// name so consumers have one import path; it is the generated lazy hook as-is
// (returns the `[getter, result]` tuple; caller passes `{ requestedResources }`
// and `onCompleted` receives the raw `{ result: { results } }` envelope).
export const useCatalogCardModelsLazy = useGetCatalogResourcesLazyQuery;